import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#D0CAE4',
} as const

export const resources = {
  loginBg: '/images/rocnovel/login/login-bg.webp',
  logo: '/images/rocnovel/login/roc-logo.png',
  novel: '/images/rocnovel/login/roc-novel.png',
  facebookIcon: '/images/rocnovel/login/icon-facebook-logo.png',
  googleIcon: '/images/rocnovel/login/icon-google-logo.png',
  appleIcon: '/images/rocnovel/login/icon-apple-logo.png',
  emailIcon: '/images/rocnovel/login/icon-email.png',
  emailCodeIcon: '/images/rocnovel/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: loginCommonConfig.texts,
}
